import { z } from 'zod';

export const createDatasetSchema = z.object({
  name: z.string().min(1),
  files: z.array(z.instanceof(File)),
});

export type CreateDatasetSchema = z.infer<typeof createDatasetSchema>;
